import './index.scss';
import classnames from 'classnames';
import { func, object } from 'prop-types';
import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import ClassificationResultsFilter from '~/components/classification_results_filter';
import ResponsiveItem from '~/components/responsive_item';
import ClauseItem from './clause_item';
const LeftPanel = ({ activeClause, document: doc, isDocumentRendered, setActiveClause }) => {
    LeftPanel.propTypes = {
        activeClause: object,
        document: object.isRequired,
        isDocumentRendered: object,
        setActiveClause: func,
    };
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedDescriptors, setSelectedDescriptors] = useState([]);
    const [panelCollapsed, setPanelCollapsed] = useState(false);
    const classificationFilterState = {
        selectedCategories,
        setSelectedCategories,
        selectedDescriptors,
        setSelectedDescriptors,
    };
    const allClauses = {};
    const uniqueCategories = new Map();
    const uniqueDescriptors = new Map();
    doc === null || doc === void 0 ? void 0 : doc.clauses.forEach(clause => {
        var _a, _b;
        const { primaryClassification, category } = clause;
        uniqueCategories.set(category.displayName, { category: category === null || category === void 0 ? void 0 : category.displayName });
        uniqueDescriptors.set(primaryClassification.displayName, {
            descriptor: primaryClassification.displayName,
        });
        if (typeof allClauses[clause.clauseName] !== 'object') {
            allClauses[clause.clauseName] = {
                id: clause.id,
                clauses: [],
                displayName: clause.clauseName,
                category: (_a = clause.category) === null || _a === void 0 ? void 0 : _a.displayName,
                descriptor: (_b = clause.primaryClassification) === null || _b === void 0 ? void 0 : _b.displayName,
            };
        }
        allClauses[clause.clauseName].clauses.push(clause);
    });
    let clauses = Object.values(allClauses);
    if (selectedCategories.length) {
        clauses = clauses === null || clauses === void 0 ? void 0 : clauses.filter(clause => selectedCategories.includes(clause.category));
    }
    if (selectedDescriptors.length) {
        clauses = clauses === null || clauses === void 0 ? void 0 : clauses.filter(clause => selectedDescriptors.includes(clause.descriptor));
    }
    let displayText = selectedCategories.join(',');
    displayText = displayText.length && selectedDescriptors.length ? displayText + ',' : displayText;
    displayText += selectedDescriptors.join(',');
    displayText = displayText.length ? displayText : 'All Classifications';
    const categories = [...uniqueCategories.keys()];
    const descriptors = [...uniqueDescriptors.keys()];
    const panelClass = classnames('left-panel', {
        collapsed: panelCollapsed,
    });
    const hideClass = classnames('fas', {
        'fa-chevron-left': !panelCollapsed,
        'fa-chevron-right': panelCollapsed,
    });
    return (React.createElement("div", { className: panelClass },
        !isDocumentRendered && React.createElement("div", { className: 'panel-overlay' }),
        React.createElement("div", { title: `${panelCollapsed ? 'Expand Panel' : 'Collapse Panel'}`, className: 'hide-icon', onClick: () => setPanelCollapsed(!panelCollapsed) },
            React.createElement("span", null,
                React.createElement("i", { className: hideClass }))),
        React.createElement("h4", null, "PDF Navigation"),
        React.createElement("div", { className: 'classification-filter-container' },
            React.createElement(ClassificationResultsFilter, { categories: categories, descriptors: descriptors, state: classificationFilterState }),
            React.createElement(ResponsiveItem, { overflowText: displayText, wrapperClassName: 'classification-filter' }, displayText)),
        React.createElement("div", { className: 'clause-items' },
            React.createElement(Accordion, { className: 'clause-accordion' }, clauses === null || clauses === void 0 ? void 0 : clauses.map(clause => {
                return React.createElement(ClauseItem, { key: clause.id, activeClause: activeClause, clause: clause, setActiveClause: setActiveClause });
            })))));
};
export default LeftPanel;
